const getBenchmarkingOptions = ({ report: { benchmarkingFilters } }) => ({
  requestStatus: benchmarkingFilters.optionsRequestStatus,
  options: benchmarkingFilters.options ? benchmarkingFilters.options : null,
});

export default getBenchmarkingOptions;
